import '../scss/section-banner-slider.scss';

import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
  const blocSliders = document.querySelectorAll('.sectionSlider');
  // console.log('swiper');
  blocSliders.forEach((bloc) => {
    const swiperContainer = bloc.querySelector('.swiper');

    if (!swiperContainer) return;

    const transitionDuration = swiperContainer.getAttribute('data-transition');
    const autoplayDelay = swiperContainer.getAttribute('data-autoplay');

    const swiper = new Swiper(swiperContainer, {
      modules: [Autoplay],
      // Optional parameters
      autoplay: {
        enabled: true,
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      // centeredSlides: true,
      loop: true,
      grabCursor: true,
      slidesPerView: 1,
      speed: transitionDuration,
      // freeMode: true,
      // spaceBetween: 10,
      // If we need pagination
      // Navigation arrows
    });
  });
});
